<template>
  <div class="main">
    <div class="title">造血干细胞简介</div>

    <div class="content">
      <div
        class="sj"
      >造血干细胞移植是目前治疗白血病最有效的方法。为了挽救白血病人的生命，中国红十字会总会于1992年组建了“中国造血干细胞捐献者资料库”，在社会各界的大力支持下，目前已经有280多万造血干细胞志愿者加入了资料库。这些志愿者的无私奉献，使白血病患者及他们的家庭获得新生，有力地促进了社会和谐。</div>

      <div
        class="sj mt20"
      >找到与病人白细胞抗原相同的造血干细胞志愿捐献者，是实施移植的前提条件。一名白血病患者在一万至十几万人中，才可能找到一个与其抗原相同者。造血干细胞捐献志愿者越多，患者获得配型成功的几率就越大，获得断生的希望就越大。</div>
    </div>
  </div>
</template>
<script>
export default {};
</script>

<style lang="less" scoped>
.main {
  box-sizing: border-box;
  padding: 24px;
  width: 100vw;
  // height: 720px;
  font-size: 14px;
  min-height: 100vh;
  background-image: url("../../assets/zxgxb/bg.png");
  background-size: cover;

  .title {
    margin-top: 120px;
    font-size: 26px;
    font-weight: bold;
  }

  .content {
    margin-top: 16px;
    padding: 25px;
    height: 500px;
    background-color: #fef2f4;
    border-radius: 10px;
  }
}
</style>